var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "aggregate_search_shop_config",
      attrs: { model: _vm.value.config, disabled: _vm.disabled },
    },
    [
      _c(
        "el-form-item",
        { staticClass: "show_type", attrs: { prop: "show_type" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("搜索的样式")]),
          _c(
            "div",
            { staticClass: "showTypeBox" },
            _vm._l(_vm.value.default_value.show_type_list, function (item) {
              return _c(
                "div",
                {
                  key: item.show_type,
                  class: [
                    "box",
                    _vm.value.config.show_type === item.show_type && "active",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeType(item)
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "icon",
                    style: { backgroundImage: "url(" + item.image + ")" },
                  }),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm.value.key === "basic_search_shop"
        ? [
            _c(
              "el-form-item",
              {
                staticClass: "margin_top",
                attrs: {
                  prop: "margin_top",
                  rules: [{ type: "number", message: "间距必须为数字值" }],
                },
              },
              [
                _c("div", [_vm._v(" 与上方组件的间距 ")]),
                _c("el-input", {
                  attrs: { placeholder: "请输入间距", clearable: "" },
                  model: {
                    value: _vm.value.config.margin_top,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
                    },
                    expression: "value.config.margin_top",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "z_index",
                attrs: {
                  prop: "z_index",
                  rules: [
                    {
                      required: true,
                      pattern: /^(?:[1-9]|[1-9][0-9])$/,
                      message: "请输入1-99之间的整数！",
                    },
                  ],
                },
              },
              [
                _c("div", [_vm._v(" 层级高度值 ")]),
                _c("el-input", {
                  attrs: { placeholder: "请输入层级高度值", clearable: "" },
                  model: {
                    value: _vm.value.config.z_index,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
                    },
                    expression: "value.config.z_index",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }